import React from 'react';
import styled from 'styled-components';
import { colors, fontSizes, Text } from '../ui-components';
import SvgEllipse from '../svg-components/svg-ellipse';
import SvgInsightBlog from '../svg-components/svg-insight-blog';
import SvgInsightDownload from '../svg-components/svg-insight-download';
import SvgInsightPodcast from '../svg-components/svg-insight-podcast';
import SvgInsightVideo from '../svg-components/svg-insight-video';

/**
 * Component that renders a heading category and date element
 *
 * @component HeadingCategoryAndDate
 * 
 * @param {object} props
 * 
 * @prop {insight} insight
 * @prop {string} fill
 * @prop {string} textFill
 * 
 * @return {JSX.Element}
 */
const HeadingCategoryAndDate = props => {
  const { insight, fill, textFill } = props;

  /**
   * Returns the JSX for the svg icon based on the TYPE of the insight - Only video and podcast have supported icons
   *
   * @function renderTypeIcon
   * @returns {JSX.Element} The JSX for the svg icon
   */
  const renderTypeIcon = () => {
    switch (insight.type) {
      case 'Blog':
        return <SvgInsightBlog fill={fill} />;
      case 'Whitepaper':
      case 'Infographic':
      case 'Ebook':
        return <SvgInsightDownload fill={fill} />;
      case 'Podcast':
        return <SvgInsightPodcast fill={fill} />;
      case 'Video':
        return <SvgInsightVideo fill={fill} />;
      default:
        return null;
    }
  };

  const publishDate = () => {
    let date = insight.getFormattedPublishDate('MMM DD, YYYY')

    if (date !== 'Invalid date') {
      return (
        <>
          <SvgEllipse fill={fill} />
          <CategoryText className={'publish-date'} size={'medium'} textFill={textFill}>{date}</CategoryText>
        </>
      );
    }
  };

  const heading = ['Whitepaper', 'Ebook'].includes(insight?.type) ? insight?.type : insight?.category?.split(',')[0];

  return (
    <SubTitleWrapper>
      {renderTypeIcon()}
      <CategoryText className={'category-name'} size={'medium'} textFill={textFill}>{heading}</CategoryText>
      {(insight.displayDate || insight.displayDate === null || insight.displayDate === undefined) && publishDate()}
    </SubTitleWrapper>
  );
};

export default HeadingCategoryAndDate;

const SubTitleWrapper = styled.div`
  display: inline-flex;
  height: 28px;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

const CategoryText = styled(props => <Text {...props} />)`
  color: ${props => props.textFill ?? colors.labelDefault};
  font-family: Lato Black, sans-serif;
  font-size: ${fontSizes.label.small.fontSize};
  font-style: normal;
  font-weight: 900;
  line-height: ${fontSizes.label.small.lineHeight};

  &.category-name {
    text-transform: uppercase;
  }
`;
